<ngx-smart-modal
  #validationWarningsModal
  class="validation-warnings-modal"
  identifier="validationWarningsModal"
  [closable]="true"
  [escapable]="false"
  [dismissible]="true"
  [showCloseButton]="true"
  [closeButtonText]="closeText"
  [showConfirmButton]="showConfirmButton"
  [confirmButtonText]="confirmText"
  [title]="title">

  <h4 class="mb-3" style="line-height:2.5rem;" *ngIf="subTitle">{{ subTitle }}</h4>

  <p class="header-message" *ngIf="headerMessage">{{ headerMessage }}</p>

  <div class="warnings-list" *ngIf="warnings.length">
    <div *ngFor="let warning of warnings" class="warning-item">
      <div [ngClass]="severity === 'error' ? 'error-icon-message' : 'warning-icon-message'">
        <rad-icon [attr.name]="severity === 'error' ? 'exclamationTriangle' : 'exclamationCircle'" size="sm"></rad-icon>
        <p>
          <span *ngIf="warning.fieldLabel" class="warning-field">{{ warning.fieldLabel }}</span>
          <span class="warning-text">{{ warning.message }}</span>
        </p>
      </div>
    </div>
  </div>

</ngx-smart-modal>
